module.exports = __webpack_public_path__ + "static/projekt_indywidualny_e07-3fe9b05f0a3223b0ea52f16223fa4b40.jpg";